import * as React from 'react';
import ConfirmationServiceContext from './confirmation-service-context';

const useConfirmation = () => React.useContext(ConfirmationServiceContext);
export default useConfirmation;
